export default __webpack_public_path__ + "static/media/factory__35.59c01a61.jpg";